import { StyleSheet } from 'aphrodite/no-important';
import { GenericObject } from 'models';
import { children, media, palette } from 'util/style-helpers';

export const style: any = (options: GenericObject) => {
  const { hide = false, hovered = false } = options;
  return StyleSheet.create({
    container: {
      display: 'none',
      position: 'absolute',
      zIndex: 2,
      top: '52vh',
      right: 0,
      flexDirection: 'column',
      [media.tablet]: {
        display: 'flex',
        right: 0,
      },
      [media.desktop]: {
        right: -17,
      },

      [children('a:not(:last-child)')]: {
        marginBottom: 5,
      },
    },
    link: {
      backgroundColor: hovered ? palette.red : palette.grey,
      color: palette.white,
      position: 'relative',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      alignSelf: 'flex-end',
      overflow: 'hidden',
      padding: 10,
      borderRadius: 24,
      transition: '.3s',
      cursor: 'pointer',
      boxShadow: '0px 3px 10px rgb(0, 0, 0, 0.5)',
      [media.tablet]: {
        display: hide ? 'none' : 'inline-flex',
      },
      [children('img')]: {
        width: 25,
        height: 25,
      },
      [children('span')]: {
        maxWidth: hovered ? 200 : 0,
        opacity: hovered ? 1 : 0,
        marginLeft: hovered ? 10 : 0,
        whiteSpace: 'nowrap',
        transition: '0.3s',
      },
    },
  });
};
